<template>
  <section v-bind:class="getClass()">

    <div v-if="this.$route.params.game === 'overwatch'">
      <img class='overwatch-logo logo-image' src="./../assets/overwatch/logo.png" alt="overwatch-logo">
      <div class='container centered' v-if="loading">
        <h3>Loading...</h3>
      </div>
      <div class='container centered' v-if="error">
        <h1>{{error}}</h1>
        <router-link :to="{ name: 'search', params: { game: this.$route.params.game }}">Back</router-link>
      </div>
      <div v-if="profileData" class="container">
        <h1 class="gamertag">
            <img :src="profileData.platformInfo.avatarUrl || nameless" alt class="platform-avatar" />
            {{ profileData.platformInfo.platformUserHandle }}
          </h1>
        <div class="grid">
          <div>
            <img :src="this.random || profileData.platformInfo.avatarUrl" alt='gamecharacter' />
          </div>
          <div>
            <ul>
              <li v-if="profileData.segments[1].stats.matchesPlayed">
                <h4>Matches Played</h4>
                <p>
                  {{profileData.segments[1].stats.matchesPlayed.displayValue}}
                  <span>({{profileData.segments[1].stats.matchesPlayed.percentile}})</span>
                </p>
              </li>
              <li v-if="profileData.segments[1].stats.wins">
                <h4>Wins</h4>
                <p>
                  {{profileData.segments[1].stats.wins.displayValue}}
                  <span>({{profileData.segments[1].stats.wins.percentile}}%)</span>
                </p>
              </li>
              <li v-if="profileData.segments[1].stats.kd">
                <h4>K/D Ratio</h4>
                <p>
                  {{profileData.segments[1].stats.kd.displayValue}}
                  <span>({{profileData.segments[1].stats.kd.percentile}}%)</span>
                </p>
              </li>
              <li v-if="profileData.segments[1].stats.eliminations">
                <h4>Lifetime Eliminations</h4>
                <p>
                  {{profileData.segments[1].stats.eliminations.displayValue}}
                  <span>({{profileData.segments[1].stats.eliminations.percentile}}%)</span>
                </p>
              </li>
              <li v-if="profileData.segments[1].stats.mostTimeSpentOnFire">
                <h4>Most Time Spend on Fire</h4>
                <p>
                  {{profileData.segments[1].stats.mostTimeSpentOnFire.displayValue}}
                  <span>({{profileData.segments[1].stats.mostTimeSpentOnFire.percentile}}%)</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <router-link :to="{ name: 'search', params: { game: this.$route.params.game }}">Back</router-link>
      </div>
      
    </div>
    <div v-else-if="this.$route.params.game === 'csgo'">
      <img class='csgo-logo logo-image' src="./../assets/csgo/csgologo.png" alt="csgologo">
      <div class='container centered' v-if="loading">
        <h3>Loading...</h3>
      </div>
      <div class='container centered' v-if="error">
        <h1>{{error}}</h1>
        <router-link :to="{ name: 'search', params: { game: this.$route.params.game }}">Back</router-link>
      </div>
      <div v-if="profileData" class="container">
        <h1 class="gamertag">
            <img :src="profileData.platformInfo.avatarUrl || nameless" alt class="platform-avatar" />
            {{ profileData.platformInfo.platformUserHandle }}
          </h1>
        <div class="grid">
          <div>
            <img :src="this.csgoRandom" alt />
          </div>
          <div>
            <ul>
              <li v-if="profileData.segments[0].stats.matchesPlayed">
                <h4>Matches Played</h4>
                <p>
                  {{profileData.segments[0].stats.matchesPlayed.displayValue}}
                  <span>({{profileData.segments[0].stats.matchesPlayed.percentile}})</span>
                </p>
              </li>
              <li v-if="profileData.segments[0].stats.wins">
                <h4>Wins</h4>
                <p>
                  {{profileData.segments[0].stats.wins.displayValue}}
                  <span>({{profileData.segments[0].stats.wins.percentile}}%)</span>
                </p>
              </li>
              <li v-if="profileData.segments[0].stats.headshots">
                <h4>Headshots</h4>
                <p>
                  {{profileData.segments[0].stats.headshots.displayValue}}
                  <span>({{profileData.segments[0].stats.headshots.percentile}}%)</span>
                </p>
              </li>
              <li v-if="profileData.segments[0].stats.bombsPlanted">
                <h4>Bombs Planted</h4>
                <p>
                  {{profileData.segments[0].stats.bombsPlanted.displayValue}}
                  <span>({{profileData.segments[0].stats.bombsPlanted.percentile}}%)</span>
                </p>
              </li>
              <li v-if="profileData.segments[0].stats.bombsDefused">
                <h4>Bombs Defused</h4>
                <p>
                  {{profileData.segments[0].stats.bombsDefused.displayValue}}
                  <span>({{profileData.segments[0].stats.bombsDefused.percentile}}%)</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <router-link :to="{ name: 'search', params: { game: this.$route.params.game }}">Back</router-link>
      </div>

    </div>
    <div v-else-if="this.$route.params.game === 'apex'">
      <img class='apex-logo logo-image' src="./../assets/apex/apexlogo.png" alt="apex=logo">
      <div class='container centered' v-if="loading">
        <h3>Loading...</h3>
      </div>
      <div class='container centered' v-if="error">
        <h1>{{error}}</h1>
        <router-link :to="{ name: 'search', params: { game: this.$route.params.game }}">Back</router-link>
      </div>
    <div v-if="profileData" class="container">
      <h1 class="gamertag">
        <img :src="profileData.platformInfo.avatarUrl" alt class="platform-avatar" />
        {{profileData.platformInfo.platformUserId}}
      </h1>
      <div class="grid">
        <div>
          <img :src="profileData.segments[1].metadata.imageUrl" alt />
        </div>
        <div>
          <ul>
            <li>
              <h4>Selected Legend</h4>
              <p>{{profileData.metadata.activeLegendName}}</p>
            </li>
            <li v-if="profileData.segments[0].stats.season2Wins">
              <h4>Season 2 Wins</h4>
              <p>
                {{profileData.segments[0].stats.season2Wins.displayValue}}
                <span>({{profileData.segments[0].stats.season2Wins.percentile}})</span>
              </p>
            </li>
            <li v-if="profileData.segments[0].stats.level">
              <h4>Apex Level</h4>
              <p>
                {{profileData.segments[0].stats.level.displayValue}}
                <span>({{profileData.segments[0].stats.level.percentile}}%)</span>
              </p>
            </li>
            <li v-if="profileData.segments[0].stats.kills">
              <h4>Lifetime Kills</h4>
              <p>
                {{profileData.segments[0].stats.kills.displayValue}}
                <span>({{profileData.segments[0].stats.kills.percentile}}%)</span>
              </p>
            <li v-if="profileData.segments[0].stats.headshots">
              <h4>Headshots</h4>
              <p>
                {{profileData.segments[0].stats.headshots.displayValue}}
                <span>({{profileData.segments[0].stats.headshots.percentile}}%)</span>
              </p>
            </li>
            </li>
            <li v-if="profileData.segments[0].stats.damage">
              <h4>Damage Done</h4>
              <p>
                {{profileData.segments[0].stats.damage.displayValue}}
                <span>({{profileData.segments[0].stats.damage.percentile}}%)</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <router-link :to="{ name: 'search', params: { game: this.$route.params.game }}">Back</router-link>
    </div>

    </div>
    <div class='not-found' v-else>
      <h2>404 Not Found</h2>
      <input v-on:click="goBackToMain" type="button" value="Back" class="btn back-btn" />
    </div>
  </section>
</template>

<script>
import axios from "axios";
const mei = require("./../assets/overwatch/mei.png");
const ashe = require("./../assets/overwatch/ashe1.png");
const genji = require("./../assets/overwatch/genji.png");
const mccree = require("./../assets/overwatch/mccree.png");
const mercy = require("./../assets/overwatch/mercy.png");
const reinhardt = require("./../assets/overwatch/reinhardt.png");
const tracer = require("./../assets/overwatch/tracer.png");
const widow = require("./../assets/overwatch/widow.png");
const lucio = require("./../assets/overwatch/lucio.png");
const bastion = require("./../assets/overwatch/bastion.png");
const nameless = require("./../assets/overwatch/nameless.png");
const csgoct = require("./../assets/csgo/csgoct.png");
const csgot = require("./../assets/csgo/csgot.png");
const overwatchHeroList = [
  ashe,
  mei,
  genji,
  mccree,
  mercy,
  reinhardt,
  tracer,
  lucio,
  bastion,
  widow
];
const csgoCharList = [ csgoct, csgot ];
let chooseRandom = array => {
  return array[Math.floor(Math.random() * array.length)];
};
export default {
  name: "Profile",
  data() {
    return {
      game: "",
      loading: false,
      error: null,
      profileData: null,
      random: "",
      csgoRandom:"",
      nameless: nameless,
      chooseRandom(array) {
        return array[Math.floor(Math.random() * array.length)];
      }
    };
  },
  beforeCreate() {
    // document.body.className = "body-bg-no-image";
    // game = this.$route.params.game;
    // this.game = this.$route.params.game;
  },
  methods: {
    getClass(){
      if(this.$route.params.game === 'overwatch'){
        return 'bg-overwatch background';
      } else if (this.$route.params.game === 'csgo'){
        return 'bg-csgo background';
      } else if (this.$route.params.game === 'apex'){
        return 'bg-apex background';
      } else return 'bg-no-image'
    }
  },
  goBackToGame(){
    this.$router.push({ name: 'search', params: { game: this.$route.params.game } });
    this.$router.go();
  },
  goBackToMain() {
    this.$router.push('/');
    this.$router.go();
    },
  async created() {
    this.random = this.chooseRandom(overwatchHeroList);
    this.csgoRandom = this.chooseRandom(csgoCharList);
    this.loading = true;
    try {
      const res = await axios.get(
        `/api/v2/profile/${this.$route.params.game}/${this.$route.params.platform}/${this.$route.params.gamertag}`
      );

      this.profileData = res.data.data;
      console.log(this.profileData);
      this.loading = false;
    } catch (err) {
      this.loading = false;
      this.error = err.response.data.message;
    }
  }
};
</script>

<style scoped>


:root {
  --primary-color: #fff1ff;
}
body {
  background: var(--primary-color);
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  line-height: 1.6;
}
.bg-no-image {
  background: var(--primary-color);
}
.bg-overwatch {
  background: rgb(191, 210, 255) url("./../assets/overwatch/ashe.png") no-repeat top center;
  background-size: 60%;
}
.bg-apex {
  background: #953036 url("./../assets/apex/apexbackground.png") no-repeat top center;
  background-size: 60%;
}
.bg-csgo {
  background: url("./../assets/csgo/csgobackground.png") no-repeat top center;
  background-size: 85%;
}
.background {
  width: 100%;
  height: 100%;
}

.logo-image {
  width: 15%;
  margin-top: 0.4rem;
  margin-left: 1rem;
}
.csgo-logo {
  margin: 1.3rem;
  margin-bottom: 3rem;
}

.overwatch-logo {
  margin-top: 1.2rem;
  margin-left: 0.6rem;
}


.container {
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  max-width: 700px;
  margin: 1rem auto;
  padding: 2rem 1.5rem;
  border-radius: 20px;
}
h1.gamertag {
  font-size: 2rem;
  background: rgba(0, 0, 0, 0.6);
  padding: 0.3rem 0.5rem;
  text-align: center;
  border-radius: 20px;
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
}
a {
  display: inline-block;
  margin-top: 2rem;
  border: #fff 2px solid;
  padding: 0.5rem 0.8rem;
}
a:hover {
  border: #ccc 2px solid;
  color: #ccc;
}
.platform-avatar {
  width: 40px;
  margin-right: 0.7rem;
}
img {
  width: 100%;
}
.centered {
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}
li {
  background: rgba(0, 0, 0, 0.6);
  padding: 1rem;
  margin-bottom: 0.7rem;
  border-radius: 10px;
}
li p {
  font-size: 2rem;
}
li:first-child p {
  font-size: 1.5rem;
}
li span {
  font-size: 1rem;
  color: #ccc;
}
@media (max-width: 500px) {
  h1 {
    font-size: 1.5rem;
    display: block;
    text-align: center;
  }
  .platform-avatar {
    display: none;
  }
  .grid {
    grid-template-columns: 1fr;
  }
  li p {
    font-size: 1.5rem;
  }
}
</style>